export const MESSAGE_TITLE_PREMIUM_OFFER = 'プレミアムオファー';

export const MESSAGE_TITLE_INTERVIEW_OFFER = '面接確約オファー';

export type NullableString = string | null;

export type NullableNumber = number | null;
